import React, { type FC, useState } from 'react'
import { Typography } from '@mui/material'

import { Translation } from '../../../domain'

import { Button } from '../common'
import { FormattedTranslation } from '../Internationalization'

export const PaginationButton: FC<{ nextPageSize: number, onClick: VoidFunction }> = ({ nextPageSize: count, onClick, ...props }) => (
    <Typography variant="body2" align="center" onClick={onClick} {...props}>
        <Button className="explorer-pagination-button" variant="primaryGhost">
            <FormattedTranslation id={Translation.SHOW_MORE} values={{ count }} />
        </Button>
    </Typography>
)

export const usePagination = <T,>(list: readonly T[], pageSize: number): readonly [loaded: readonly T[], nextPageButton: ReturnType<FC> | null] => {
    const [limited, setLimited] = useState(1)

    const totalSize = limited * pageSize
    const nextPage = Math.min((limited + 1) * pageSize, list.length) - totalSize

    return [list.slice(0, totalSize), nextPage > 0 ? <PaginationButton nextPageSize={nextPage} onClick={() => setLimited((limited) => ++limited)} /> : null]
}
